var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { JobList } from 'packages/job_lists/JobList';
import { CancelablePromise } from 'packages/core/CancelablePromise';
import { LandingPage } from 'packages/landing_pages/LandingPage';
import { EntityBuilder } from '@decahedron/entity';
import { Pagination } from 'packages/core/Pagination';
import env from 'config/env';
var PublicJobListRepository = /** @class */ (function (_super) {
    __extends(PublicJobListRepository, _super);
    function PublicJobListRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'api/v2/job-lists/public/';
        _this.entity = JobList;
        _this.baseUrl = env.JOBILLA_API_ROOT;
        return _this;
    }
    PublicJobListRepository.prototype.getListStringId = function (id, token) {
        var _this = this;
        if (token === void 0) { token = null; }
        return this.get(this.url + ":id", { id: id }, { resource_access_token: token }).then(function (_a) {
            var data = _a.data;
            return EntityBuilder.buildOne(_this.entity, _this.responseTransformer(data));
        });
    };
    PublicJobListRepository.prototype.getLandingPagesForStringId = function (id, paging, name, location, token) {
        var _this = this;
        var filter = {};
        if (name) {
            filter.name = name;
        }
        if (location) {
            filter.location = location;
        }
        return this.get(this.url + ":id/landing-pages", { id: id }, {
            filter: filter,
            page: paging.currentPage,
            per_page: paging.perPage,
            resource_access_token: token,
        }).then(function (response) {
            var result = _this.responseTransformer(response);
            return {
                items: EntityBuilder.buildMany(LandingPage, result.data),
                pagination: EntityBuilder.buildOne(Pagination, result.meta),
            };
        });
    };
    PublicJobListRepository.prototype.getLocations = function (jobListStringId) {
        return __awaiter(this, void 0, CancelablePromise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.get("/api/v3/job-lists/" + jobListStringId + "/locations")
                        .then(function (r) { return _this.responseTransformer(r).data; })];
            });
        });
    };
    PublicJobListRepository.prototype.getActiveJobList = function (companyId) {
        var _this = this;
        return this.get("/api/v2/companies/" + companyId + "/job-list")
            .then(function (_a) {
            var data = _a.data;
            return EntityBuilder.buildOne(_this.entity, _this.responseTransformer(data));
        })
            .catch(function (error) {
            if (error.response.status === 404) {
                return null;
            }
            throw error;
        });
    };
    return PublicJobListRepository;
}(AbstractRepository));
export { PublicJobListRepository };
